import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'newlinesToHtmlBreak',
    standalone: false
})
export class NewlinesToHtmlBreakPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/g, '<br/>');
  }
}
